const BOMB_NUMBER = 404;

export { BOMB_NUMBER };
